import { render, staticRenderFns } from "./InventoryByBox.vue?vue&type=template&id=8d00362c&"
import script from "./InventoryByBox.vue?vue&type=script&lang=js&"
export * from "./InventoryByBox.vue?vue&type=script&lang=js&"
import style0 from "./InventoryByBox.vue?vue&type=style&index=0&id=8d00362c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports